import React from 'react';

const SvgText = (props) => {
  const { className, children, fontSize = '12px' } = props;
  // return <div className={className} style={{background: 'red'}}><MdAccessibility className={className}/>🐻</div>
  return (
    <div className={`${className}`}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
        <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" style={{ fontSize }}>
          {children}
        </text>
      </svg>
    </div>
  );
};

export default SvgText;
